import type { DocumentFromResponse } from 'shared/features/documents/documents.types';

export const EXCLUSIVE_FIELDS: (keyof DocumentFromResponse)[] = [
  'id',
  'title',
  'publication_date',
  'has_sentences'
];
